import { useRouter } from 'next/router';
import { HeaderMenu } from '@bettercomp/ui-components';
import type { MenuProps } from 'antd';
import { useNavigationConfig } from './navigationConfig';

type NavMenuProps = {
  mode?: MenuProps['mode'];
  onClick?: () => void;
};

function getSelectedKeys(items: any[], pathname: string): string[] {
  for (const item of items) {
    if (item.children) {
      for (const child of item.children) {
        if (child.key === pathname) {
          return [item.key, child.key];
        }
      }
    } else if (item.key === pathname) {
      return [item.key];
    }
  }
  return [];
}

export const NavMenu = ({ mode = 'horizontal', onClick }: NavMenuProps) => {
  const router = useRouter();
  const navigationConfig = useNavigationConfig();
  const selectedKeys = getSelectedKeys(navigationConfig, router.pathname);

  const navigate = (item: { key: string }) => {
    if (item.key) {
      router.push(item.key);
    }
    onClick?.();
  };

  return (
    <HeaderMenu
      mode={mode}
      selectedKeys={selectedKeys}
      onClick={navigate}
      items={navigationConfig}
      data-testid="navMenu"
    />
  );
};
